<template>
  <div class="nav" :style="{ width: navList.length * 400 + 'px' }">
    <router-link
      tag="div"
      v-for="nav in navList"
      :key="nav.name"
      :to="nav.path"
      class="menu_item"
      active-class="menu_item_ac"
    >
      <div class="txt">{{ nav.meta.showName }}</div>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Nav',
  data() {
    return {
      navList: []
    };
  },
  created() {
    this.navList = this.$router.options.routes.filter(item => {
      return item.path != "/" && item.path != "/login";
    });
  },
  methods: {},
  computed: {
    ...mapState(['topic'])
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.nav {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 1100px;
  height: 124px;
  display: flex;
  justify-content: space-between;
  pointer-events: all;
  margin-left: -50px;
  .menu_item {
    font-family: 'Helvetica';
    width: 430px;
    height: 124px;
    font-size: 40px;
    text-align: center;
    line-height: 38px;
    font-weight: bold;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    .txt {
      color: #ebebeb;
      text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.75);
    }
  }
  .menu_item_ac {
    background: url(../../assets/img/layout/nav-bg-ac.png) no-repeat center center;
    .txt {
      color: #97dfff;
      font-size: 40px;
      text-shadow: none;
    }
  }
}
</style>
